import { render, staticRenderFns } from "./mdBackQueryShSubmitToAction.vue?vue&type=template&id=321bdd93&scoped=true"
import script from "./mdBackQueryShSubmitToAction.vue?vue&type=script&lang=js"
export * from "./mdBackQueryShSubmitToAction.vue?vue&type=script&lang=js"
import style0 from "./mdBackQueryShSubmitToAction.vue?vue&type=style&index=0&id=321bdd93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321bdd93",
  null
  
)

export default component.exports